<template>
  <RouterView />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onMounted, onUnmounted } from 'vue'
import { useModal } from '@/composables/useModal';
import { usePodStore } from '@/stores/pod'
import * as Sentry from "@sentry/vue";

function handleRenderError(event: Event) {
  if (event instanceof CustomEvent && event.type === 'rendererror' && import.meta.env.VITE_ENV !== 'testing') {
    useModal(
      'Er is iets mis gegaan',
      '<div class="flex flex-col gap-4"><p>Er is een fout opgetreden tijdens het laden van het 3D model. Vernieuw de pagina om dit te verhelpen.</p><p>Werkt dit niet? <a class="text-brand-green" href="https://opuspod.nl/contact" target="_blank">Neem dan contact met ons op</a>.</p><button class="button-orange-contained md:w-fit" onclick="location.reload()">Opnieuw proberen</button></div>')
  }

  Sentry.captureMessage("Apparaat ondersteunt geen 3D-weergave", "warning");
}

function handle3DError() {

  if (import.meta.env.VITE_ENV !== 'testing') {
    useModal(
      'Er is iets mis gegaan',
      '<div class="flex flex-col gap-4"><p>Mogelijk dat jouw apparaat of browser de 3D-weergave niet ondersteund.<br><br>Ga verder zonder 3D-weergave of probeer het op een ander apparaat.</p><button class="button-orange-contained md:w-fit" onclick="location.reload()">Verder gaan</button></div>',
      null,
      false)

    // TODO: Add Sentry Event
    Sentry.captureMessage("Apparaat ondersteunt geen 3D-weergave", "warning");
  }

  const pod = usePodStore();
  pod.renderActive = false;
}

onMounted(() => {
  // Listen for rendererror events on the window
  window.addEventListener('rendererror', handleRenderError)
  window.addEventListener('no3DSupport', handle3DError)
})

// Remove the listener
onUnmounted(() => {
  window.removeEventListener('rendererror', handleRenderError)
  window.removeEventListener('no3DSupport', handle3DError)
})

</script>
